import Link from 'next/link'
import { useRouter } from 'next/router'

import useSubscriptionBoxContractDetails from '@lib/hooks/useSubscriptionBoxContractDetails'
import type { NavItems } from '@lib/types/account-ui'

type Props = {
	isIndexNavPage?: boolean
	navItems: NavItems
	showNav?: boolean
	setShowNav: (showNav: boolean) => void
}

export default function AccountVerticalNav({
	isIndexNavPage,
	navItems,
	showNav = true,
	setShowNav
}: Props) {
	const router = useRouter()

	// Fetch subscription details
	const { subscriptioBoxContractDetails, loading } = useSubscriptionBoxContractDetails()
	const { isSubscriptionGift } = subscriptioBoxContractDetails || {}

	// Show nav once isSubscriptionGift is fetched
	return loading ? (
		<div aria-hidden="true" />
	) : (
		<nav
			className={`lg:border-x lg:border-b lg:border-gray-200 flex flex-col max-lg:absolute max-lg:inset-0 bg-white lg:bg-bbx-pearl-lightest z-[11] ${
				isIndexNavPage || showNav ? '' : 'max-lg:hidden'
			}`}
		>
			<div className="bg-bbx-pearl-lightest lg:bg-none">
				{navItems.map(({ label, url, svgCode, filePathName }) =>
					url === '/profile/account/payment-methods' && isSubscriptionGift ? null : (
						<Link legacyBehavior href={url} key={label}>
							<a
								key={url}
								href={url}
								className={`flex flex-row items-center justify-between py-6 transition duration-200 ease-in-out border-b px-2 lg:px-9 nav-item border-gray-200 hover:bg-gray-100 ${
									router.pathname === filePathName ? 'current bg-bbx-pearl-light' : ''
								}`}
								onClick={() => setShowNav(false)}
							>
								<div className="flex flex-row items-center gap-x-3">
									<i className={`${svgCode} w-3`} />
									<span className="whitespace-nowrap">{label}</span>
								</div>
								<i className="w-2 fa-thin fa-chevron-right" />
							</a>
						</Link>
					)
				)}
			</div>
		</nav>
	)
}
